const hourToMiliseconds = (time) => {
    return Number(time?.split(':')[0]) * 60 * 60 * 1000 + Number(time?.split(':')[1]) * 60 * 1000 + Number(time?.split(':')[2]) * 1000;
  }
  
export default hourToMiliseconds;